export default {
  zones: [],
  zonesPolygon: [],
  slots: [],
  orders: [],
  couriers: [],
  routingResult: [],
  loading: false,
  reloadOrders: false,
  selectedOrders: [],
  selectedCouriers: [],
  taskId: '',
  routingPoints: [],
  routingPointsColor: '',
  routingInfo: [],
  routeTaskDetail: [],
  setConfirmDisabled: true,
  selectedSlots: [],
  slotsParentType: '',
  selectedSubZones: [],
  selectedZoneId: '',
  subZonesByZone: [],
  selectedZoneForRouteMonitoring: '',
  routeMonitoringTaskId: '',
  routeMonitoringRouteTaskId: '',
  routeDetailPageSelectedCourierIdx: null,
  selectedCourierMapMarkers: null,
  allCouriers: [],
  selectedZone: null,
  selectedRoutingDetailData: null,
};
